import React from 'react';
import { theme } from '../styles/theme';

export const Footer = () => {
  return (
    <footer style={{
      backgroundColor: theme.colors.white,
      borderTop: `1px solid ${theme.colors.border}`,
      padding: '40px',
    }}>
      {/* Responsive CSS */}
      <style>{`
        @media (max-width: 768px) {
          footer {
            padding: 24px 20px !important;
          }
          .footer-content {
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 24px !important;
          }
          .footer-links {
            flex-wrap: wrap !important;
            gap: 16px !important;
          }
        }
      `}</style>
      <div className="footer-content" style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        color: theme.colors.textTertiary,
        fontSize: '14px',
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
        }}>
          <img
            src="/ManuscriptMatchLogo.svg"
            alt="Manuscript Match Logo"
            style={{
              width: '32px',
              height: '32px',
              opacity: 0.6,
            }}
          />
          <span>© {new Date().getFullYear()} Manuscript Match</span>
        </div>
        <div className="footer-links" style={{
          display: 'flex',
          gap: '24px',
        }}>
          <a
            href="mailto:contact@manuscriptmatch.com"
            style={{
              color: theme.colors.textTertiary,
              textDecoration: 'none',
              transition: 'color 0.2s',
            }}
            onMouseOver={(e) => e.currentTarget.style.color = theme.colors.primary}
            onMouseOut={(e) => e.currentTarget.style.color = theme.colors.textTertiary}
          >
            Contact
          </a>
        </div>
      </div>
    </footer>
  );
};
